import {proxy, useSnapshot} from 'valtio';
import type {BuyflowStep, BuyflowWidget} from '@/lib/TypesOpenApi';

export const waitMessage = proxy({message: ''});

export const useWaitMessage = () => useSnapshot(waitMessage);

export function setWaitWidget(step: BuyflowStep | undefined) {
  const buyflowWidgets = (step?.buyflowWidgets as BuyflowWidget[]) ?? [];
  const waitWidget = buyflowWidgets.find(
    widget => widget.waitWidget?.message !== undefined,
  );
  const message = waitWidget?.waitWidget?.message ?? '';

  waitMessage.message = message;
}
